/* Odliczanie na hero bannerze (gg-hero-promo). Czyta data-end (+ opcjonalne data-start),
   renderuje Dni : Godziny : Minuty : Sekundy, tyka co sekundę. Etykiety z data-l-* (zlokalizowane).
   Pokazuje się tylko między start a end; po końcu znika. Wzór wizualny jak na gymglamour-shoper. */
(function () {
  function parse(str) {
    if (!str) return NaN;
    // "2026-06-10 15:00:00" -> traktuj jak czas lokalny
    return Date.parse(str.trim().replace(' ', 'T'));
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init(el) {
    var end = parse(el.dataset.end);
    if (isNaN(end)) return;
    var start = el.dataset.start ? parse(el.dataset.start) : null;
    if (start !== null && isNaN(start)) start = null;

    var L = {
      d: el.dataset.lDays || 'Dni',
      h: el.dataset.lHours || 'Godziny',
      m: el.dataset.lMinutes || 'Minuty',
      s: el.dataset.lSeconds || 'Sekundy'
    };

    function item(cls, label) {
      return '<div class="gg-cd__item gg-cd__item--' + cls + '">' +
        '<span class="gg-cd__value" data-' + cls + '>0</span>' +
        '<span class="gg-cd__name">' + label + '</span></div>';
    }
    var sep = '<span class="gg-cd__sep">:</span>';
    el.innerHTML = item('d', L.d) + sep + item('h', L.h) + sep + item('m', L.m) + sep + item('s', L.s);

    var vD = el.querySelector('[data-d]'), vH = el.querySelector('[data-h]'),
        vM = el.querySelector('[data-m]'), vS = el.querySelector('[data-s]');

    var timer = null;
    function tick() {
      var now = Date.now();
      if (start !== null && now < start) { el.style.visibility = 'hidden'; return; }
      var dist = end - now;
      if (dist <= 0) {
        el.style.display = 'none';
        if (timer) clearInterval(timer);
        return;
      }
      el.style.visibility = '';
      vD.textContent = Math.floor(dist / 86400000);
      vH.textContent = pad(Math.floor((dist % 86400000) / 3600000));
      vM.textContent = pad(Math.floor((dist % 3600000) / 60000));
      vS.textContent = pad(Math.floor((dist % 60000) / 1000));
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  function run() {
    document.querySelectorAll('[data-gg-countdown]').forEach(init);
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
